(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hf-christmas-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('christmas-countdown')) {
    customElements.define('christmas-countdown', class ChristmasCountdown extends HTMLElement {
      connectedCallback() {
        this.days = this.querySelector('[data-countdown-days]');
        this.hours = this.querySelector('[data-countdown-hours]');
        this.minutes = this.querySelector('[data-countdown-minutes]');
        this.seconds = this.querySelector('[data-countdown-seconds]');
        this.update();
        this.interval = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      update() {
        const now = new Date();
        let christmas = new Date(now.getFullYear(), 11, 25, 0, 0, 0);

        if (now >= christmas) {
          christmas = new Date(now.getFullYear() + 1, 11, 25, 0, 0, 0);
        }

        const remaining = Math.max(0, christmas.getTime() - now.getTime());
        this.days.textContent = String(Math.floor(remaining / 86400000)).padStart(2, '0');
        this.hours.textContent = String(Math.floor((remaining % 86400000) / 3600000)).padStart(2, '0');
        this.minutes.textContent = String(Math.floor((remaining % 3600000) / 60000)).padStart(2, '0');
        this.seconds.textContent = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
